<template>
  <div v-if="tableData">
    <updated-list-component
      :table-headers="tableHeaders"
      :table-data="generateHomeSearchData(tableData)"
      @resend-invite-clicked="onSendInviteClicked($event)"
      @client-clicked="onClientNameClicked($event)"
      @clicked="onInitialSearchClicked($event)"
    />
  </div>
</template>

<script>
import UpdatedListComponent from '../../uiUtils/UpdatedListComponent.vue'
import colors from '../../../scss/_colors.scss'
import moment from 'moment'
import { dateOfLastInvite } from '../../../services/invite-service'
import { mapMutations } from 'vuex'

export default {
  components: { UpdatedListComponent },
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      tableHeaders: [
        { text: '', value: 'clientName', sortable: false },
        {
          text: 'Initial Search',
          value: 'initialSearch',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Last Active',
          value: 'lastActive',
          sortable: false,
          align: 'center'
        }
      ],
      colors
    }
  },

  methods: {
    ...mapMutations('client', {
      setAssignToClient: 'SET_ASSIGN_TO_CLIENT'
    }),

    generateHomeSearchData(tableDataArray) {
      let responseData = []
      tableDataArray.forEach((item, index) => {
        const lastActivity = item.lastActivity ? moment(item.lastActivity).format('MM-DD-YY')
          : !this.getDateOfLastInvite(item) ? 'RESEND INVITE' : 'SENT'
        let rowObject = {}
        rowObject[0] = {
          type: 'avatar',
          text: item.name,
          class: 'textLeft hwayzTeal text-capitalize',
          data: { value: item, action: 'client-clicked' } }
        rowObject[1] = {
          type: 'icon',
          color: colors.hwayzBlack,
          text: 'search',
          data: item
        }
        if (lastActivity === 'RESEND INVITE') {
          rowObject[2] = {
            type: 'clickableText',
            text: lastActivity,
            color: colors.hwayzBrandGold,
            сlass: 'resend-invite-btn',
            data: {
              type: 'resendInviteClick',
              value: item,
              action: 'resend-invite-clicked'
            }
          }
        } else {
          rowObject[2] = {
            type: 'text',
            text: lastActivity,
            class: 'blue-color'
          }
        }
        if (item.homes.length === 0) {
          responseData.push(rowObject)
        }
      })
      return responseData
    },

    onClientNameClicked(data) {
      this.$emit('client-clicked', data)
    },

    onInitialSearchClicked(data) {
      this.setAssignToClient(data)
      this.$router.push({ name: 'agent-search' })
    },
    getDateOfLastInvite(item) {
      return dateOfLastInvite(item)
    },
    onSendInviteClicked(data) {
      this.$emit('resend-invite-clicked', data)
    }
  }
}
</script>

<style lang="sass" scoped>
.theme--light.v-table tbody
  tr:hover:not(.v-datatable__expand-row)
    background-color: $hwayzWhite
  tr:not(:last-child)
    border-style: none

</style>
<style lang="sass">
.blue-color, .resend-invite-btn:hover
  color: $hwayzBrandBlue !important
</style>
